import { render } from "./IconBase.vue?vue&type=template&id=fc65514a&scoped=true&ts=true"
import script from "./IconBase.vue?vue&type=script&lang=ts"
export * from "./IconBase.vue?vue&type=script&lang=ts"

import "./IconBase.vue?vue&type=style&index=0&id=fc65514a&scoped=true&lang=css"

import exportComponent from "/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc65514a"]])

export default __exports__